export default __webpack_public_path__ + "images/a51a7ba3d5ed1204fbc40953bf5bc124-cultural_music.jpg";